// src/components/ErrorBoundary.js
import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Aktualisiert den Zustand, damit die nächste Renderung die Fallback-UI zeigen kann
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Sie können den Fehler auch an ein Fehlerberichtssystem senden
        console.error("Caught an error:", error, errorInfo);
        this.setState({ errorInfo });
    }

    render() {
        if (this.state.hasError) {
            // Sie können eine eigene Fehleransicht rendern
            return (
                <div>
                    <h2>Something went wrong.</h2>
                    <details style={{ whiteSpace: 'pre-wrap' }}>
                        {this.state.error && this.state.error.toString()}
                        <br />
                        {this.state.errorInfo?.componentStack || ''}
                    </details>
                </div>
            );
        }

        // Wenn alles in Ordnung ist, rendern Sie die Kinderkomponenten
        return this.props.children;
    }
}

export default ErrorBoundary;
